export const modes = [
	'Bytebeat',
	'Signed Bytebeat',
	'Floatbeat',
	'Funcbeat',
	'Bitbeat',
	'Signed Floatbeat',
	'Signed Funcbeat',
	'Signed Bitbeat',
	'2048',
	'Logmode',
	'LogHack',
	'LogHack2',
	'LogHack3',
	'LogNatHack',
	'postfix',
	'Sinmode',
	'Sinfreq',
	'Logmode10',
	'RAW',
	'Inverted Bytebeat',
	'Tanmode',
	'Signed RAW',
	'FloatRAW',
	'4080',
	'8160',
	'Tanhmode',
	'Atanmode',
	'Cosmode',
	'Absmode',
	'Cbrtmode',
	'Sinhmode',
	'Asinmode',
	'Acosmode',
	'Coshmode',
	'Sqrtmode',
	'Sinfmode',
	'Tanfmode',
	'Cosfmode',
	'DoubleBeat',
	'No Limit',
	'2Beat',
	'127Beat',
	'256Beat',
	'Glitch',
	'Wordbeat',
	'Signed Wordbeat',
	'2beat (Valve2x)',
	'Signed 2Beat (Valve2x)',
	'LogarithmicBeat (log scale)',
	'2048 Mode (0-2047)',
	'Custom Range',
	'Quantized Beat',
	'PWM Beat',
	'AM Beat (Amplitude Modulation)',
	'PM Beat (Phase Modulation)',
	'FM Beat (Frequency Modulation)',
	'Shifted Sawtooth Beat',
	'FloatLimit (Low-precision float)',
	'Trianglemode',
	'Squaremode',
	'Semisinemode',
	'Beatmode',
	'CWI Mode',
	'CWI2 Mode',
	'CWI (t-Mod) Mode',
	'CWI2 (t-Mod) Mode',
	'CWI (t-Mod Melody) Mode',
	'CWI2 (t-Mod Melody) Mode',
	'|t|-t Mode',
	'Sharp 3n+1',
	'TanBR Mode',
	'TanBS Mode',
	'Complex Sawtooth Beat',
	'Complex AbsMod Wave',
	'Cosecant Mode',
	'randombeat',
	'byte2beat',
	'reduxbeat',
	'float3beat',
	'float4beat',
	'float5beat',
	'bytetribeat',
	'bytesqurbeat',
	'bytesiebeat',
	'bytesmisbeat',
	'floattribeat',
	'floatsqurbeat',
	'floatsiebeat',
	'floatsmisbeat',
	'functribeat',
	'funcsqurbeat',
	'funcsiebeat',
	'funcsmisbeat',
	'FSDmode',
	'TUNNELmode',
	'pattern-67',
	'pattern-69',
	'pattern-twelve',
	'one-pattern',
	'duo-pattern',
	'tri-pattern',
	'float6beat',
	'float7beat',
	'func2beat',
	'func3beat',
	'func4beat',
	'bytesite',
	'floatsite',
	'funcsite',
	'bit2beat',
	'bit3beat',
	'bit4beat',
	'bit5beat',
	'malware2wavebeat',
	'malware4wavebeat',
	'malware5wavebeat',
	'malware6wavebeat',
	'random6beat',
	'random7beat',
	'samplemode',
	'sample2mode',
	'sample3mode',
	'sample4mode',
	'sample5mode',
	'NeurofunkMode',
	'reduxflag',
	'complex-saw-melody'
];
